<template>
  <el-row :gutter="10">
    <el-col :xs="24"
            :span="5">
      <el-card shadow="none">
        <div slot="header">
          <span><i class="el-icon-discount mr-10"></i>应急开门</span>
        </div>
        <el-input class="mb-15"
                  placeholder="输入关键字进行过滤"
                  v-model="filterText">
        </el-input>
        <el-tree class="remote-tree"
                 ref="remoteTree"
                 highlight-current
                 default-expand-all
                 :expand-on-click-node="false"
                 node-key="id"
                 :current-node-key="currentKey"
                 :data="orgList"
                 :props="defaultProps"
                 :filter-node-method="filterNode"
                 @node-click="handleNodeClick">
        </el-tree>
      </el-card>
    </el-col>
    <el-col :xs="24"
            :span="19">
      <el-row>
        <el-button v-has="'/person/list/lock/urgentOpen'"
                   type="primary"
                   @click="multipleOpen">批量开门</el-button>
      </el-row>
      <el-card shadow="none"
               class="mt-15">
        <el-table max-height="575"
                  ref="multipleTable"
                  :data="tableData"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="80"></el-table-column>
          <el-table-column label="序号"
                           type="index"
                           width="60"></el-table-column>
          <el-table-column v-for="(item, index) in tableTitle"
                           :fixed="item.fixed"
                           :key="index"
                           :label="item.name"
                           :prop="item.prop"
                           :min-width="item.width"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <template v-if="item.prop === 'status'">
                <el-tag type="success">开启</el-tag>
              </template>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="80">
            <template slot-scope="scope">
              <el-button v-has="'/person/list/lock/urgentOpen'"
                         size="mini"
                         type="primary"
                         @click="handleOpen(scope.row)">开门</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <Pagination :total="pagination.total"
                    :pageSize="pagination.perPage"
                    @handleSizeChange="handleSizeChange"
                    @handleCurrent="handleCurrentChange"></Pagination> -->
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
// import Pagination from '@/components/pagination/Pagination'
export default {
  // components: { Pagination },
  data() {
    return {
      filterText: '',
      currentKey: 1,
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      orgList: [],
      searchForm: {
        name: '',
        type: ''
      },
      tableTitle: [
        {
          prop: 'area_names',
          name: '所属区域',
          width: '120'
        },
        {
          prop: 'name',
          name: '网关名称',
          width: '150'
        },
        {
          prop: 'remarks',
          name: '备注',
          width: '150'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加假日相关
      showRoomModal: false,
      roomData: {
        type: 'add'
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.remoteTree.filter(val)
    }
  },
  created() {
    this.getAreaTree().then(() => {
      this.getList()
    })
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      return Promise.resolve(
        fetch
          .urgentLockList({
            area_id: this.currentKey,
            perPage: perPage,
            currentPage: currentPage,
            ...this.searchForm
          })
          .then((data) => {
            data.procData(
              data.res,
              (data) => {
                this.pagination.total = Number(data.total)
                this.tableData = data.list
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
      )
    },
    // 获取树结构数据
    getAreaTree() {
      return Promise.resolve(
        fetch.getAreaTree({}).then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.orgList = data.treeData
              this.currentKey = data.treeData[0].id
              this.$nextTick(function () {
                this.$refs.remoteTree.setCurrentKey(data.treeData[0].id)
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      )
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 树形菜单单击
    handleNodeClick(data) {
      this.currentKey = data.id
      this.getList()
    },
    // 开门
    handleOpen(data) {
      this.$confirm('是否确定开启该设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.urgentOpen(data.id)
        })
        .catch(() => {})
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 批量开门
    multipleOpen() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定开启选中的设备?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.urgentOpen(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择房间后重试')
      }
    },
    urgentOpen(ids) {
      fetch.urgentOpen({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.$message.success('操作成功')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style lang="less">
.remote-tree.el-tree {
  .el-tree-node__content {
    height: 30px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>
